export default __webpack_public_path__ + "static/media/x.042d50b6.svg";